export default "__VITE_ASSET__68182428__"